// @flow
import type { AxiosError } from "../helpers/types";
import type { FeaturesData } from "../reducers/featured";

export const REQUEST_FEATURED = "REQUEST_FEATURED";
export const requestFeatured = (auction: number, locale: string) => ({
  type: REQUEST_FEATURED,
  auction,
  locale
});

export const REQUEST_FEATURED_SUCCESS = "REQUEST_FEATURED_SUCCESS";
export const requestFeaturedSuccess = (data: FeaturesData) => ({
  type: REQUEST_FEATURED_SUCCESS,
  data
});

export const REQUEST_FEATURED_FAILED = "REQUEST_FEATURED_FAILED";
export const requestFeaturedFailed = (error: AxiosError) => ({
  type: REQUEST_FEATURED_FAILED,
  error
});



// WEBPACK FOOTER //
// ./src/redux/actions/featured.js